module.exports = __webpack_public_path__ + "media/images/emblems/Scheuren-coat_of_arms-abfe030e7637252b361803607359937a.svg";